import styled from 'styled-components'
import { theme } from '@/client/components'
const { color, space } = theme

export const MoreInfos = styled.div`
  position: relative;
  padding-top: ${space.xl5};
  padding-bottom: ${space.xl3};
  background-color: ${color.grayscale.light};
  overflow: hidden;
`
